// extracted by mini-css-extract-plugin
export default {"base":"DataQuality_base__zbsyE","cell":"DataQuality_cell__a-q1n"};